import { Requisition } from '../types';

export interface TypeConfig {
  label: string;
}

export const requisitionStatusConfig = {
  draft: {
    id: 'draft',
    color: '#FAA238',
    label: 'Draft',
  },
  pending_approval: {
    id: 'pending_approval',
    label: 'Pending approval',
    color: '#CC7914',
  },
  approved: {
    id: 'approved',
    label: 'Approved',
    color: '#0B7B69',
  },
  rejected: {
    id: 'rejected',
    label: 'Not approved',
    color: '#FF4141',
  },
  created: {
    id: 'created',
    label: 'Ready to open',
    color: '#0B7B69',
  },
  open: {
    id: 'open',
    label: 'Open',
    color: '#73D017',
  },
  closed: {
    id: 'closed',
    label: 'Closed',
    color: '#C03744',
  },
  archived: {
    id: 'archived',
    label: 'Archived',
    color: '#585858',
  },
  filled: {
    id: 'filled',
    label: 'Filled',
    color: '#585858',
  },
};

export const requisitionTypeConfig: Record<
  Requisition['requisition_type'],
  TypeConfig
> = {
  new_hire: {
    label: 'New hire',
  },
  backfill: {
    label: 'Backfill',
  },
  internal: {
    label: 'Internal',
  },
};
